/** จัดรูปแบบตัวเลข/วันที่แบบไทย — ใช้ทั่วทั้ง admin ให้เหมือนกันหมด */
export function num(n: number | null | undefined): string {
  return new Intl.NumberFormat('th-TH').format(n ?? 0);
}

export function pct(n: number | null | undefined, digits = 1): string {
  return `${(n ?? 0).toFixed(digits)}%`;
}

export function bytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export function date(iso: string | null | undefined, withTime = false): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('th-TH', {
    day: 'numeric', month: 'short', year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(d);
}

export function relative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diff / 60000);
  const rtf = new Intl.RelativeTimeFormat('th-TH', { numeric: 'auto' });
  if (Math.abs(mins) < 60) return rtf.format(-mins, 'minute');
  if (Math.abs(mins) < 1440) return rtf.format(-Math.round(mins / 60), 'hour');
  if (Math.abs(mins) < 43200) return rtf.format(-Math.round(mins / 1440), 'day');
  return date(iso);
}

/** input[type=datetime-local] ต้องการเวลาท้องถิ่นในรูป YYYY-MM-DDTHH:mm */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export const PLAN_LABEL: Record<string, string> = {
  FREE: 'Free', STARTER: 'Starter', GROWTH: 'Growth', PRO: 'Pro', ENTERPRISE: 'Enterprise',
};

export const ROLE_LABEL: Record<string, string> = {
  OWNER: 'เจ้าของ', ADMIN: 'ผู้ดูแล', EDITOR: 'บรรณาธิการ',
  AUTHOR: 'ผู้เขียน', VIEWER: 'ผู้อ่าน',
};

export const STATUS_LABEL: Record<string, string> = {
  DRAFT: 'ฉบับร่าง', IN_REVIEW: 'รอตรวจ', SCHEDULED: 'ตั้งเวลา',
  PUBLISHED: 'เผยแพร่แล้ว', ARCHIVED: 'เก็บถาวร',
  ACTIVE: 'ใช้งาน', PAUSED: 'หยุดชั่วคราว', TRIAL: 'ทดลองใช้',
  SUSPENDED: 'ระงับ', CANCELLED: 'ยกเลิก', INVITED: 'รอตอบรับ',
};
